import React from "react";
import { Col, Row, Container, Card } from "react-bootstrap";
import imgAboutUs from "../../../assets/images/aboutUs-2.svg";
import imgAboutUs1 from "../../../assets/images/aboutUs-1.svg";
import { isMobile } from "react-device-detect";
function AboutUs() {
  return (
    <Container fluid className={!isMobile ? " min-height-page" : ""}>
      <Container className="py-3 fs-normal line-height-2 text-align-justify">
        <Row className="px-3 mt-3 pt-4 bg-white rounded-4 shadow-sm">
          <Col xs="12">
            <h1 className=" fs-102 pb-3">درباره ما</h1>
            <p>
              <span>تفریحان، </span> مکانی است که تجربه‌ها به خاطرات شیرین تبدیل
              می‌شوند.
              <br />
              ارائه خدمات خرید بلیط تفریحات به بیش از 100,000 نفر در ایران
              تفریحان، مرکز خرید بلیط تفریحات در تمامی شهرهای ایران است، این
              مجموعه از سال 1400 فعالیت خود را آغاز کرده است و دارای مجوز رسمی
              از سازمان منطقه آزاد کیش و وزارت صنعت، معدن و تجارت (ای نماد) است.
            </p>
            <h2 className="fs-101"> لذت و تجربه‌های متفاوت تفریحی</h2>
            <p>
              <span>تفریحان،</span> با افتخار یکی از معتبرترین و پیشروترین
              برندهای گردشگری و تفریحی ایران است که تحت مدیریت شرکت{" "}
              <span className=" mx-1"> رایان سفر نیکان کیش </span>
              فعالیت می‌کند. از همان ابتدای کار، هدف ما ایجاد تجربه‌های
              منحصربه‌فرد و مفرح برای همه اقشار جامعه بوده است. در دنیای امروز
              که تنش‌ها و فشارهای روزمره زندگی می‌تواند روحیه انسان‌ها را
              تحت‌تأثیر قرار دهد، ما بر این باوریم که تفریح و استراحت یک نیاز
              اساسی برای افزایش کیفیت زندگی است. بنابراین، در تفریحان تلاش داریم
              تا با ارائه خدمات و پیشنهادات تفریحی، همگان بتوانند از لذت‌های
              کوچک و بزرگ زندگی بهره‌مند شوند.
            </p>
          </Col>
          <Col xs="12">
            <h2 className="fs-101">ماموریت ما: ساخت لحظاتی به یاد ماندنی</h2>
            <p>
              شرکت <span>رایان سفر نیکان کیش</span>، به عنوان هسته اصلی مدیریت
              تفریحان، همواره تمرکز خود را بر طراحی و توسعه برنامه‌ها و خدمات
              گردشگری و تفریحی در سراسر کشور قرار داده است. ماموریت ما این است
              که لحظاتی فراموش‌ نشدنی برای مشتریانمان خلق کنیم. با تیمی مجرب و
              کارشناسان زبده در زمینه گردشگری، سعی داریم بهترین و متفاوت‌ترین
              تجربه‌های سفر و تفریح را به مشتریان خود ارائه دهیم.
            </p>
          </Col>
          <Col xs="12">
            <h2 className="fs-101">فعالیت‌ها و خدمات ما</h2>

            <p>
              در <span>تفریحان،</span> طیف گسترده‌ای از خدمات و برنامه‌های
              تفریحی در اختیار شما قرار دارد. از تورهای طبیعت‌ گردی و ماجراجویی
              گرفته تا تفریحات آبی و فرهنگی. همچنین، ما همکاری‌های گسترده‌ای با
              مراکز تفریحی و گردشگری مختلف در سراسر ایران داریم تا بتوانیم
              بهترین فرصت‌های تفریحی را به شما معرفی کنیم.
            </p>
          </Col>
          <Col lg="8">
            <p>
              <div>خدمات ما شامل موارد زیر است:</div>
              <ul className="ps-3">
                <li>
                  <span className="fw-bold">تورهای تفریحی و طبیعت‌گردی: </span>
                  به طبیعت سفر کنید و از مناظر بکر و زیبای ایران لذت ببرید.
                </li>
                <li>
                  <span className="fw-bold">تفریحات آبی و ورزشی: </span> از
                  هیجان تفریحات دریایی در سواحل خلیج فارس و دریای کاسپین تا رزرو
                  تمامی مجموعه های آبی لذت ببرید.
                </li>
                <li>
                  <span className="fw-bold">جنگ های شبانه شاد و مفرح: </span>
                  با خرید بلیط های کنسرت، جنگ شادی، کشتی های تفریحی، تئاتر و...
                  در لحظه ها شاد باشید.
                </li>
                <li>
                  <span className="fw-bold">
                    پارک های بازی و مجموعه های هیجان انگیز:
                  </span>
                  از ترشح آدرنالین در شهربازی ها، اتاق فرار، پیست های سرعتی تا
                  خرید بلیط تم پارک های سراسر کشور در تفریحان
                </li>
                <li>و...</li>
              </ul>
            </p>
          </Col>
          <Col className="d-sm-none d-lg-block" lg="4">
            <img src={imgAboutUs} className="w-100" alt="about us" />
          </Col>
          <Col xs="12">
            <p>
              هر یک از این خدمات، با توجه به نیازها و سلایق مختلف مشتریان، طراحی
              و برنامه‌ریزی شده‌اند تا بتوانند لحظاتی خاص و به‌یادماندنی برای
              شما رقم بزنند.
            </p>
          </Col>
          <Col xs="12">
            <h2 className="fs-101">ارزش‌های تفریحان</h2>

            <p>
              <div>
                ما در <span>تفریحان</span> به ارزش‌های بنیادی خود پایبندیم و بر
                اساس این اصول، فعالیت‌ها و خدماتمان را بهبود می‌دهیم:
              </div>
              <ul className="ps-3">
                <li>
                  <span className="fw-bold"> کیفیت بالا: </span>
                  اولویت اصلی ما ارائه خدمات با کیفیت و رضایت‌بخش است. تیم ما
                  همواره در تلاش است تا با ارائه بهترین امکانات و تجربه‌ها،
                  لبخند را بر لبان مشتریان بنشاند.
                </li>
                <li>
                  <span className="fw-bold">تجربه منحصربه‌فرد: </span>
                  ما معتقدیم که هر تفریحی باید به یک تجربه بی‌نظیر و
                  فراموش‌نشدنی تبدیل شود. تلاش ما این است که با ارائه برنامه‌های
                  خاص و خلاقانه، خاطراتی خوش را برای شما خلق کنیم.
                </li>
                <li>
                  <span className="fw-bold">شفافیت و صداقت: </span>
                  در تمامی مراحل، از رزرو خدمات تا اجرای آن، ما با مشتریان خود
                  با صداقت و شفافیت کامل برخورد می‌کنیم. هدف ما ایجاد اعتماد و
                  ارتباطی پایدار با شماست.
                </li>
                <li>
                  <span className="fw-bold">پایداری و حفظ محیط زیست: </span>
                  ما به حفاظت از طبیعت و محیط زیست پایبندیم و همواره تلاش داریم
                  تا با رعایت استانداردهای زیست‌محیطی، به حفظ طبیعت ایران کمک
                  کنیم.
                </li>
              </ul>
            </p>
          </Col>
          <Col lg="8" className="my-auto">
            <h2 className="fs-101">چرا تفریحان؟</h2>
            <p>
              <ul className="ps-3">
                <li>
                  <span className="fw-bold">تجربه و تخصص: </span>
                  با سال‌ها تجربه در صنعت گردشگری و تفریحات، ما به خوبی نیازها و
                  خواسته‌های مشتریان خود را درک کرده‌ایم و می‌دانیم چگونه آن‌ها
                  را به بهترین شکل برآورده کنیم.
                </li>
                <li>
                  <span className="fw-bold">تنوع خدمات: </span>
                  از گردش‌های طبیعت‌گردی تا تفریحات شهری و فرهنگی، تفریحان تمامی
                  سلایق و علایق شما را پوشش می‌دهد.
                </li>
                <li>
                  <span className="fw-bold">قیمت‌های مناسب: </span>
                  ما همواره تلاش کرده‌ایم تا خدمات باکیفیت را با قیمت‌های
                  مقرون‌به‌صرفه ارائه دهیم تا همه افراد بتوانند از فرصت‌های
                  تفریحی لذت ببرند.
                </li>
                <li>
                  <span className="fw-bold">پشتیبانی 24 ساعته: </span> تیم
                  پشتیبانی ما در تمامی مراحل کنار شماست و در صورت بروز هرگونه
                  سوال یا مشکل، به سرعت پاسخگوی شما خواهد بود.
                </li>
              </ul>
            </p>
          </Col>
          <Col lg="4" className="d-sm-none d-lg-block">
            <img src={imgAboutUs1} className="w-100" alt="about us" />
          </Col>
          <Col xs="12">
            {/* <h2 className="fs-101">برنامه‌های آتی</h2>

            <p>
              <div>
                در تفریحان، همواره به دنبال گسترش و بهبود خدمات خود هستیم. در
                آینده‌ای نزدیک، برنامه‌های جدیدی از جمله:
              </div>
              <ul>
                <li>
                  <span className="fw-bold">تورهای بین‌المللی: </span>
                  تجربه سفر به مقاصد گردشگری خارج از کشور.
                </li>
                <li>
                  <span className="fw-bold">تفریحات اکوتوریسم: </span>
                  برنامه‌هایی برای ارتباط بیشتر با طبیعت و محافظت از آن.
                </li>
              </ul>
            </p> */}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default AboutUs;
